export const API_SERVER = process.env.REACT_APP_DASHBOARD_API_URL;;

export const UserRole = ["Admin", "Regular", "Bookkeeper"];